export const objects = {
    "Region": {
        "regionId": "string",
        "orgId": "string",
        "lang": "string",
        "country": "string",
        "area": "string",
        "city": "string",
        "lat": "double",
        "lng": "double",
        "fullName": "string",
        "googlePlaceId": {
            "googlePlaceId": "string",
            "countryEn": "string",
            "areaEn": "string",
            "cityEn": "string",
            "countryRu": "string",
            "areaRu": "string",
            "cityRu": "string",
            "countryUa": "string",
            "areaUa": "string",
            "cityUa": "string",
            "countryPl": "string",
            "areaPl": "string",
            "cityPl": "string"
        },
        "fromGoogle": "boolean",
        "displayCountry": "string",
        "displayCity": "string",
        "displayFullName": "string"
    },
    "Contact": {
        "contactId": "string",
        "personType": "ObjectTypeEnum",
        "personId": "string",
        "type": "ContactTypeEnum",
        "value": "string",
        "orgId": "string"
    }
    ,
    "Skill": {
        "skillId": "string",
        "orgId": "string",
        "objName": "ObjectTypeEnum",
        "objId": "string",
        "name": "string",
        "level": "number (1 - 5)",
    }
    ,
    "Language": {
        "languageId": "string",
        "name": "string",
        "level": "LanguageLvEnum",
        "orgId": "string",
        "objId": "string",
        "objType": "ObjectTypeEnum",
        "dc": "Date",
        "creatorId": "string",
    }
    ,
    "Field": {
        "fieldId": "string",
        "orgId": "string",
        "objType": "ObjectTypeEnum",
        "state": "'A' - active, 'D' - deleted",
        "type": "FieldTypeEnum",
        "title": "string",
        "dc": "Date",
        "params (dropdown fields)":

            [
                {
                    "fieldParamId": "string",
                    "orgId": "string",
                    "name": "defaultValue/option",
                    "value": "string"
                }

            ],
        "orderIndex": "number",
        "mandatory": "boolean"
    }
    ,
    "PageInfo":
        {
            "number": "number",
            "count": "number"
        },
    "Interview":
        {
            "interviewId": "string",
            "state": "InterviewStateEnum",
            "status": "InterviewStatusEnum",
            "dc": "Date",
            "dm": "number",
            "dateInterview": "number",
            "comment": "string",
            "vacancy": "string",
            "candidate": "string",
            "creatorId": "string",
            "candidateId (candidate)":
                {}
        }

    ,
    "FieldValue":
        {
            "objType": "ObjectTypeEnum",
            "value": "string",
            "field": {
                "fieldId": "string"
            }
        }

    ,
    "Person":
        {
            "personId": "string",
            "userId": "string",
            "firstName": "string",
            "middleName": "string",
            "lastName": "string",
            "login": "string",
            "sex": "boolean",
            "contacts":
                [],
            "orgs":
                [],
            "roles":
                [],
            "status": "'A' - active, 'D' - deleted",
            "recrutRole": 'RoleEnum',
            "countUnreadNotice": "number",
            "countAllNotice": "number",
            "otherSessionsRemoves": false,
            "phone": "string",
            "photoLink": "string",
            "level": "string",
            "cutFullName": "string",
            "cutFullNameEn": "string",
            "fullName": "string"
        }
    ,
    "Action":
        {
            "actionId": "string",
            "orgId": "string",
            "personId": "string",
            "status": "'A' - active, 'D' - deleted",
            "type": "ActionTypeEnum",
            "descr": "string",
            "dm": "number",
            "clientId": "string",
            "candidateId": "string",
            "source": "string",
            "taskId": "string",
            "testId": "string",
            "mailTemplateId": "string",
            "scoreCardId": "string",
            "employeeId": "string",
            "stateOld": "string",
            "stateNew": "string",
            "person (Person object)": {},
            "client (Client object)": {},
            "creatorId": "string"
        }

    ,
    "ContactClient":
        {
            "contactClientId": "string",
            "localId": "string",
            "firstName": "string",
            "lastName": "string",
            "sex": "boolean",
            "status": "'A' - active, 'D' - deleted",
            "dc": "Date",
            "creatorId": "string",
            "clientId (Client object)": {}
        }
}